import { DatetimeMonthFormat, FormatName, MonthFormat } from 'app/lib/datetime/types';

import type { SupportedLang, tFunction } from 'app/lang';

import dictionary from './datetime.dictionary.json';

export const MONTH_FORMATS: Record<DatetimeMonthFormat, MonthFormat> = {
  full: 'MMMM',
  short: 'MMM',
  oneLetter: 'MMMMM',
};

export const DATE_FORMATS = (
  month: MonthFormat,
): Record<SupportedLang, Record<FormatName, string>> => ({
  ru: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Только что',
  },
  en: {
    numeric: 'MM/dd/yyyy',
    numericWithTime: 'MM/dd/yyyy, h:mm a',
    time: 'h:mm a',
    timeWithSeconds: 'h:mm:ss a',
    short: `${month} dd`,
    shortWithYear: `${month} dd, yyyy`,
    long: `${month} dd, h:mm a`,
    longWithYear: `${month} dd, yyyy h:mm a`,
    // just: 'Just',
  },
  uz: {
    numeric: 'dd/MM/yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Hozirgina',
  },
  kk: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Жана ғана',
  },
  ky: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Азыр эле',
  },
  tg: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Танҳо',
  },
});

export const getFriendlyDateFormats = (t: tFunction, lang: SupportedLang) => {
  let formatTime = 'HH:mm';

  if (lang === 'en') {
    formatTime = 'h:mm a';
  }

  return {
    yesterday: {
      default: t(dictionary.yesterday),
      withTime: t(dictionary.yesterdayWithTime, { formatTime }),
    },
    today: {
      default: t(dictionary.today),
      withTime: t(dictionary.todayWithTime, { formatTime }),
    },
    tomorrow: {
      default: t(dictionary.tomorrow),
      withTime: t(dictionary.tomorrowWithTime, { formatTime }),
    },
  };
};
